module.exports = __webpack_public_path__ + "static/media/dollar.7682f515.svg";